import React from 'react';
import Why_01 from '../../../assets/images/why-choose/why-choose-three-1.png';

const WhyChouse = () => {
    return (
        <>
            <div className="why-choose-section-three">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="why-choose-details-three">
                                <div className="heading-box">
                                    <h2
                                        className="heading-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                    >
                                        Offering an innovative attitude towards We See Solutions Growing
                                        for your Business
                                    </h2>
                                </div>
                                <p
                                    className="lead animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Bring your ideas to life with an intuitive visuals editor. Create,
                                    edit, and customize your website visually and see the changes
                                    instantly.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why-choose-image-three">
                                <img src={Why_01} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="why-choose-lower-three">
                        <div className="why-choose-container">
                            <div className="why-choose-box-three">
                                <span>
                                    <svg
                                        width={48}
                                        height={35}
                                        viewBox="0 0 48 35"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M37 14.375C38.8923 14.3736 40.7589 14.8135 42.4514 15.6597C44.1439 16.506 45.6158 17.7353 46.75 19.25"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1.25 19.25C2.38424 17.7353 3.85609 16.506 5.54862 15.6597C7.24114 14.8135 9.1077 14.3736 11 14.375"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M24 27.375C28.4873 27.375 32.125 23.7373 32.125 19.25C32.125 14.7627 28.4873 11.125 24 11.125C19.5127 11.125 15.875 14.7627 15.875 19.25C15.875 23.7373 19.5127 27.375 24 27.375Z"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M12.625 33.875C13.7915 31.8954 15.4545 30.2546 17.4494 29.1146C19.4444 27.9746 21.7023 27.375 24 27.375C26.2977 27.375 28.5556 27.9746 30.5506 29.1146C32.5455 30.2546 34.2085 31.8954 35.375 33.875"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M30.7031 6.25C31.007 5.07302 31.6349 4.00484 32.5154 3.16677C33.3959 2.3287 34.4937 1.75433 35.6843 1.50888C36.8748 1.26344 38.1103 1.35676 39.2505 1.77824C40.3907 2.19972 41.3898 2.93247 42.1344 3.89329C42.879 4.8541 43.3393 6.00446 43.463 7.21374C43.5867 8.42301 43.3688 9.64273 42.834 10.7344C42.2993 11.826 41.4691 12.7458 40.4379 13.3894C39.4066 14.0329 38.2156 14.3744 37 14.375"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M11.0006 14.375C9.78505 14.3744 8.594 14.0329 7.56275 13.3894C6.53149 12.7458 5.70135 11.826 5.16662 10.7344C4.63188 9.64273 4.41397 8.42301 4.53763 7.21374C4.6613 6.00446 5.12158 4.8541 5.86621 3.89329C6.61084 2.93247 7.60998 2.19972 8.75015 1.77824C9.89032 1.35676 11.1258 1.26344 12.3164 1.50888C13.5069 1.75433 14.6048 2.3287 15.4853 3.16677C16.3658 4.00484 16.9936 5.07302 17.2975 6.25"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                                <h4>Experience</h4>
                                <p>
                                    Build long-term relationships with your clients based on trust, open
                                    communication, and the mutual respect.
                                </p>
                            </div>
                            <div className="why-choose-box-three">
                                <span>
                                    <svg
                                        width={50}
                                        height={50}
                                        viewBox="0 0 50 50"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M42.1875 9.375H7.8125C6.94956 9.375 6.25 10.0746 6.25 10.9375V34.375C6.25 35.2379 6.94956 35.9375 7.8125 35.9375H42.1875C43.0504 35.9375 43.75 35.2379 43.75 34.375V10.9375C43.75 10.0746 43.0504 9.375 42.1875 9.375Z"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M31.25 35.9375L37.5 43.75"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M18.75 35.9375L12.5 43.75"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M18.75 23.4375V28.125"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M25 20.3125V28.125"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M31.25 17.1875V28.125"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M25 9.375V4.6875"
                                            stroke="#56736C"
                                            strokeWidth="2.34375"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                                <h4>Strategic Marketing</h4>
                                <p>
                                    The company experiences is to empower you with tools and the shape
                                    to make pure information decisions
                                </p>
                            </div>
                            <div className="why-choose-box-three">
                                <span>
                                    <svg
                                        width={41}
                                        height={34}
                                        viewBox="0 0 41 34"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M28.3438 16.6406C29.3361 16.6406 30.1406 15.8361 30.1406 14.8438C30.1406 13.8514 29.3361 13.0469 28.3438 13.0469C27.3514 13.0469 26.5469 13.8514 26.5469 14.8438C26.5469 15.8361 27.3514 16.6406 28.3438 16.6406Z"
                                            fill="#56736C"
                                        />
                                        <path
                                            d="M16.125 6.9375H23.3125"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M34.8125 1.1875H21.875"
                                            stroke="#56736C"
                                            strokeWidth="2.15625"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M35.5924 11.25H36.25C37.0125 11.25 37.7438 11.5529 38.2829 12.0921C38.8221 12.6312 39.125 13.3625 39.125 14.125V19.875C39.125 20.6375 38.8221 21.3688 38.2829 21.9079C37.7438 22.4471 37.0125 22.75 36.25 22.75H34.8125L31.5602 31.8584C31.4604 32.1378 31.2766 32.3795 31.0341 32.5503C30.7915 32.7211 30.502 32.8127 30.2053 32.8125H27.9197C27.623 32.8127 27.3335 32.7211 27.091 32.5503C26.8484 32.3795 26.6646 32.1378 26.5649 31.8584L25.8802 29.9375H13.5573L12.8727 31.8584C12.7729 32.1378 12.5891 32.3795 12.3466 32.5503C12.104 32.7211 11.8145 32.8127 11.5178 32.8125H9.2322C8.93551 32.8127 8.64602 32.7211 8.40345 32.5503C8.16088 32.3795 7.97711 32.1378 7.87735 31.8584L5.52345 25.2656C3.09289 22.6192 1.746 19.1557 1.75001 15.5625C1.75001 11.75 3.26451 8.09368 5.96035 5.39784C8.65618 2.70201 12.3125 1.1875 16.125 1.1875H21.875C24.6801 1.18669 27.4241 2.0066 29.769 3.54619C32.1138 5.08578 33.9569 7.27777 35.0713 9.85203C35.2684 10.3089 35.4423 10.7755 35.5924 11.25Z"
                                            stroke="#56736C"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                                <h4>Saving Costs</h4>
                                <p>
                                    The current investment landscape requires a robust approach to
                                    investments and staying informed of market
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default WhyChouse
